/* Oath Jewelry - Blog hub enhancement (progressive, vanilla) */
(function () {
  var root = document.querySelector('.oath-blog');
  if (!root) return;
  document.documentElement.classList.add('js');

  var grid = root.querySelector('.bhub-grid');
  if (!grid) return;

  var searchInput = root.querySelector('.bhub-search__input');
  var sortSelect = root.querySelector('.bhub-sort__select');
  var countEl = root.querySelector('.bhub-count');
  var clearBtn = root.querySelector('.bhub-clear');
  var moreBtn = root.querySelector('.bhub-more');
  var emptyEl = root.querySelector('.bhub-empty');
  var headingEl = root.querySelector('.bhub-lib__heading');
  var libEl = root.querySelector('.bhub-lib');
  var navEl = root.querySelector('.bhub-browse');
  var startWrap = root.querySelector('.bhub-start');
  var startCards = root.querySelector('.bhub-start__cards');
  var cornerTpl = document.getElementById('bhub-corner-tpl');

  var scope = root.getAttribute('data-scope') || 'all';
  var basePath = window.location.pathname;
  var totalPages = parseInt(root.getAttribute('data-total-pages'), 10) || 1;

  var STEP = 24;
  var state = { q: '', topic: '', sort: 'newest', limit: STEP };
  var cards = [];
  var seen = {};
  var currentTag = root.getAttribute('data-current-tag') || '';
  if (scope === 'tag' && currentTag) state.topic = currentTag;

  function indexCard(el) {
    var id = el.getAttribute('data-id') || '';
    if (id && seen[id]) return;
    if (id) seen[id] = true;
    var tags = (el.getAttribute('data-tags') || '').split(',').filter(Boolean);
    cards.push({
      el: el,
      id: id,
      title: el.getAttribute('data-title') || '',
      tags: tags,
      search: el.getAttribute('data-search') || '',
      date: parseInt(el.getAttribute('data-date'), 10) || 0,
      rt: parseInt(el.getAttribute('data-rt'), 10) || 0,
      pillar: el.getAttribute('data-pillarpost') === '1'
    });
  }

  Array.prototype.forEach.call(grid.querySelectorAll('.bhub-card'), indexCard);

  function matched() {
    return cards.filter(function (c) {
      if (state.topic && c.tags.indexOf(state.topic) === -1) return false;
      if (state.q && c.search.indexOf(state.q) === -1) return false;
      return true;
    });
  }

  function sortList(list) {
    var s = state.sort;
    list.sort(function (a, b) {
      if (s === 'oldest') return a.date - b.date;
      if (s === 'az') return a.title < b.title ? -1 : (a.title > b.title ? 1 : 0);
      if (s === 'read') return a.rt - b.rt;
      return b.date - a.date;
    });
    return list;
  }

  function activeLabel() {
    var label = state.topic;
    Array.prototype.forEach.call(root.querySelectorAll('.bhub-chip, .bhub-month'), function (ch) {
      if ((ch.getAttribute('data-topic') || '') === state.topic) {
        label = ch.getAttribute('data-label') || ch.textContent;
      }
    });
    return label;
  }

  function countChips() {
    Array.prototype.forEach.call(root.querySelectorAll('.bhub-chip'), function (ch) {
      var span = ch.querySelector('.bhub-chip__n');
      if (!span) return;
      var t = ch.getAttribute('data-topic') || '';
      span.textContent = t ? cards.filter(function (c) { return c.tags.indexOf(t) !== -1; }).length : cards.length;
    });
  }

  function render() {
    countChips();
    cards.forEach(function (c) { c.el.classList.add('is-hidden'); });
    var list = sortList(matched());
    for (var i = 0; i < list.length; i++) {
      list[i].el.style.order = i;
      if (i < state.limit) list[i].el.classList.remove('is-hidden');
    }
    if (countEl) {
      if (list.length === cards.length && !state.q && !state.topic) {
        countEl.innerHTML = '<strong>' + cards.length + '</strong> articles';
      } else {
        countEl.innerHTML = '<strong>' + list.length + '</strong> of ' + cards.length + ' articles';
      }
    }
    if (emptyEl) emptyEl.classList.toggle('is-on', list.length === 0);
    if (moreBtn) moreBtn.classList.toggle('is-on', list.length > state.limit);
    if (clearBtn) clearBtn.classList.toggle('is-on', !!(state.q || state.topic));
    Array.prototype.forEach.call(root.querySelectorAll('.bhub-chip, .bhub-month'), function (ch) {
      ch.classList.toggle('is-active', (ch.getAttribute('data-topic') || '') === state.topic);
    });
    if (headingEl) headingEl.textContent = state.topic ? activeLabel() : 'Latest Articles';
  }

  function renderStart() {
    if (!startWrap || !startCards || !cornerTpl || !cornerTpl.content) return;
    var picks = cards.filter(function (c) { return c.pillar; }).slice(0, 8);
    if (!picks.length) return;
    startCards.innerHTML = '';
    picks.forEach(function (c) {
      var node = cornerTpl.content.cloneNode(true);
      var a = node.querySelector('.bhub-corner');
      var srcA = c.el.querySelector('.bhub-card__title a');
      var srcEx = c.el.querySelector('.bhub-card__ex');
      if (a && srcA) a.setAttribute('href', srcA.getAttribute('href') || '#');
      var t = node.querySelector('.bhub-corner__title');
      if (t && srcA) t.textContent = srcA.textContent;
      var ex = node.querySelector('.bhub-corner__ex');
      if (ex && srcEx) ex.textContent = srcEx.textContent;
      startCards.appendChild(node);
    });
    startWrap.classList.add('is-ready');
  }

  function afterLoad() { renderStart(); render(); }

  function prefetch() {
    if (totalPages < 2) { afterLoad(); return; }
    var pending = totalPages - 1;
    var done = function () { pending--; if (pending <= 0) afterLoad(); };
    for (var p = 2; p <= totalPages; p++) {
      var url = basePath + (basePath.indexOf('?') === -1 ? '?' : '&') + 'page=' + p;
      fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (!html) return;
          try {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            Array.prototype.forEach.call(doc.querySelectorAll('.bhub-grid .bhub-card'), function (n) {
              var id = n.getAttribute('data-id') || '';
              if (id && seen[id]) return;
              var imported = document.importNode(n, true);
              grid.appendChild(imported);
              indexCard(imported);
            });
          } catch (e) {}
        })
        .catch(function () {})
        .then(done);
    }
  }

  var searchForm = root.querySelector('form.bhub-search');
  if (searchForm) searchForm.addEventListener('submit', function (e) { e.preventDefault(); if (searchInput) { state.q = searchInput.value.trim().toLowerCase(); state.limit = STEP; render(); } if (libEl) libEl.scrollIntoView({ behavior: 'smooth', block: 'start' }); });

  if (searchInput) searchInput.addEventListener('input', function () {
    state.q = this.value.trim().toLowerCase();
    state.limit = STEP;
    render();
  });
  if (sortSelect) sortSelect.addEventListener('change', function () {
    state.sort = this.value;
    render();
  });
  if (moreBtn) moreBtn.addEventListener('click', function () {
    state.limit += STEP;
    render();
  });
  if (clearBtn) clearBtn.addEventListener('click', function () {
    state.q = '';
    state.topic = '';
    state.limit = STEP;
    if (searchInput) searchInput.value = '';
    render();
  });

  function onChip(e) {
    if (scope !== 'all') return;
    e.preventDefault();
    var t = this.getAttribute('data-topic') || '';
    state.topic = (state.topic === t && t !== '') ? '' : t;
    state.limit = STEP;
    render();
    if (libEl) libEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  Array.prototype.forEach.call(root.querySelectorAll('.bhub-chip, .bhub-month'), function (ch) {
    ch.addEventListener('click', onChip);
  });

  Array.prototype.forEach.call(root.querySelectorAll('[data-scroll]'), function (btn) {
    btn.addEventListener('click', function (e) {
      var which = this.getAttribute('data-scroll');
      var target = which === 'nav' ? navEl : libEl;
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
  });

  render();
  prefetch();
})();
